import { ReactElement, useEffect, useMemo, useRef, useState } from "react";
import { TUserWorkflow, TUserWorkflowTask } from "./logic/useUserWorkflow";
import { Button } from "@zendeskgarden/react-buttons";
import { useHistory } from "react-router-dom";
import {Paragraph} from "@zendeskgarden/react-typography";
import css from "./styles/user-workflows.module.scss";
import { ArrowRight, CheckCircle, CheckCircleOutline } from "@material-ui/icons";
import { TaskStatusType } from "../../__generated__/generated_types";
import { Field, MediaInput } from "@zendeskgarden/react-forms";
import { ReactComponent as SearchIcon } from '@zendeskgarden/svg-icons/src/16/search-stroke.svg';
import cn from "classnames";


export interface IUserWorkflowOverviewProps {
    workflow: TUserWorkflow;
    activeTask?: TUserWorkflowTask;
    visibilityChanged?: boolean;
}

export function UserWorkflowOverview({workflow, activeTask, visibilityChanged}: IUserWorkflowOverviewProps): ReactElement {
    const history = useHistory();
    const [filterText, setFilterText] = useState("");
    const activeTaskRef = useRef<HTMLLIElement>(null);

    useEffect(() => {
        if (activeTaskRef.current) {
            activeTaskRef.current.scrollIntoView({
                block: "center",
            });
        }
    }, [visibilityChanged]);

    const filteredTasks = useMemo(() => {
        return workflow.tasks.filter(task => task.title.toLowerCase().includes(filterText.toLowerCase()));
    }, [workflow]);

    return (
        <div className={css.uwOverview}>
            <h4>{workflow.title}</h4>

            <Paragraph className={css.description} size="medium">
                {workflow.description}
            </Paragraph>

            <h5>Task List</h5>

            <Field className={css.searchField}>
                <MediaInput
                    start={<SearchIcon />}
                    placeholder="Search Tasks"
                    onChange={(evt) => {
                        setFilterText(evt.target.value);
                    }}
                />
            </Field>

            <ol className={css.taskList}>
                {
                    filteredTasks.map(task =>
                        <li key={task.id} className={css.taskListItem} ref={task.id == activeTask?.id ? activeTaskRef : null}>
                            { task.currentStatus && task.currentStatus.status == TaskStatusType.Complete ?
                                <CheckCircle className={css.taskCompleteIcon} />
                                : <CheckCircleOutline className={css.taskPendingIcon} />
                            }

                            <Button
                                className={cn(css.taskNavButton, task.id == activeTask?.id && css.currentTask)}
                                onClick={() => history.push(`/workflow/${task.id}/reforecast`)}
                                disabled={task.id == activeTask?.id}
                                isBasic
                            >
                                <ArrowRight className={css.currentTaskIcon} />
                                {task.title}
                            </Button>
                        </li>
                    )
                }
            </ol>
        </div>
    );
}
